import MockAdapter from "axios-mock-adapter";

import contactsData from './data/contacts.json';
import settingsData from './data/settings.json';

let contacts = contactsData;
let settings = settingsData;

export const isMockEnabled = () => {
    return process.env.REACT_APP_MOCK_ENABLED === 'true'
};

export const initializeAxiosMockAdapter = (instance) => {

    const mock = new MockAdapter(instance);    

    //Signin
    mock.onPost("/api/user/signin").reply(data => authenticate(data));

    //Settings
    mock.onGet("/api/settings").reply(() => getSettings());
    mock.onPost("/api/settings").reply(() => postSettings(settingsData));

    //Assets    
    mock.onPost("/api/update").reply(() => postAsset({}));
    mock.onDelete("/api/delete").reply(() => deleteAsset({}));
};

//**
// crmService
//**
export const authenticate = (data) => {
    const body = JSON.parse(data.data);
    
    const item = contacts.value.find(c => c.name === body.username);
    if(item){
        return [200, body.username];
    } else {    
        return [401, {
            "value":[]
        }];
    }
};

//**
// settingsService GET
//**
export const getSettings = () => {
    return [200, settings];
};

//**
// settingsService POST
//**
export const postSettings = (settings) => {
    return [200, settings];
};

//**
// settingsService POST
//**
export const postAsset = (asset) => {
    return [200, asset];
};

//**
// settingsService POST
//**
export const deleteAsset = (asset) => {
    return [204, asset];
};
